import "./Empty.scss";

export const Empty = ({ empty_message }) => {
  return (
    <div className="empty">
      <p>{empty_message}</p>
    </div>
  );
};
